const appConfig = {
  version: '4.0.0'
};

export default appConfig;
    